var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewPolicyDetailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.562 3.696a2 2 0 01-.313 2.81l-10 8a2 2 0 01-2.498 0l-8.75-7-8.752 7a2 2 0 11-2.498-3.123l10-8a2 2 0 012.499 0l8.75 7 8.75-7a2 2 0 012.812.313zM5 20.945a2 2 0 012 2v14a2 2 0 01-4 0v-14a2 2 0 012-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.945a2 2 0 10-4 0v20a2 2 0 004 0v-20zM25 20.945a2 2 0 012 2v14a2 2 0 01-4 0v-14a2 2 0 012-2zM37 16.945a2 2 0 10-4 0v20a2 2 0 004 0v-20z"
  }))));
}

export default SvgNewPolicyDetailIcon;